module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5d2d256b465345ebd2b47a76534b185a.png";